import React from 'react';
import { Phone, Send } from 'lucide-react';
import { FadeIn } from './ScrollReveal';
import { trackContactEvent } from '../utils/analytics';
import { getSiteSettings } from '../utils/cms';

const CTA = () => {
  const settings = getSiteSettings();

  const handlePhoneClick = () => {
    trackContactEvent('cta_phone', settings.phone);
    window.location.href = `tel:${settings.phone}`;
  };

  const handleContactClick = () => {
    trackContactEvent('cta_contact_form', 'scroll_to_form');
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-stone-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <FadeIn>
          <h2 className="text-3xl font-light text-stone-800 mb-6">
            Kostenlose Beratung anfragen
          </h2>
          <p className="text-lg text-stone-600 mb-8 max-w-2xl mx-auto">
            Haben Sie Fragen zu Ihrem Fliesenprojekt? Kontaktieren Sie mich für ein unverbindliches Gespräch.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handlePhoneClick}
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg transition-colors duration-200 flex items-center space-x-2"
            >
              <Phone className="w-5 h-5" />
              <span>{settings.phone}</span>
            </button>
            
            <button
              onClick={handleContactClick}
              className="border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white px-8 py-3 rounded-lg transition-colors duration-200 flex items-center space-x-2"
            >
              <Send className="w-5 h-5" />
              <span>Nachricht senden</span>
            </button>
          </div>
          
          <p className="text-sm text-stone-500 mt-6">
            Mo-Fr 8:00-17:00 Uhr • Kostenlose Beratung vor Ort
          </p>
        </FadeIn>
      </div>
    </section>
  );
};

export default CTA; 